import { StringMap } from './shared'

export interface NavLanguage {
    isHighlighted: boolean,
    label: string,
    locale: string,
    refMarker: string
}

export enum NavigationIdentifiers {
    PV_NAV_HOME = "pv-nav-home",
    PV_NAV_MOVIES = "pv-nav-movies",
    PV_NAV_TV_SHOWS = "pv-nav-tv-shows",
    PV_NAV_KIDS = "pv-nav-kids",
    PV_NAV_CHANNELS = "pv-nav-channels",
    PV_NAV_STORE = "pv-nav-store",
    PV_NAV_RENT_OR_BUY = "pv-nav-rent-or-buy",
    PV_NAV_MYSTUFF = "pv-nav-mystuff",
    PV_NAV_ORIGINALS = "pv-nav-originals",
    PV_NAV_YOUR_ACCOUNT = "pv-nav-your-account",
    PV_NAV_YOUR_WATCHLIST = "pv-nav-your-watchlist",
    PV_NAV_PURCHASES_AND_RENTALS = "pv-nav-purchases-and-rentals",
    PV_NAV_SETTINGS = "pv-nav-settings",
    PV_NAV_WATCH_ANYWHERE = "pv-nav-watch-anywhere",
    PV_NAV_HELP = "pv-nav-help",
    PV_NAV_GETTING_STARTED = "pv-nav-getting-started",
    PV_NAV_SIGN_IN = "pv-nav-sign-in",
    PV_NAV_SIGN_OUT = "pv-nav-sign-out",
    PV_NAV_EPL = "pv-nav-epl",
    PV_NAV_SALE = "pv-nav-sale",
    vPV_NAV_BLURAY = "pv-nav-bluray",
    PV_NAV_SPORTS = "pv-nav-sports",
    PV_NAV_PRIME_FILTERS = "pv-nav-prime-filters",
    
    PV_NAV_LOCALE_PREFIX = "pv-nav-locale",
    
    PV_NAV_CATEGORIES = "pv-nav-categories",
    PV_NAV_CATEGORIES_MOVIES = "pv-nav-categories-movies",
    PV_NAV_CATEGORIES_TVSHOWS = "pv-nav-categories-tv-shows",
    PV_NAV_CATEGORIES_INCLUDED_WITH_PRIME = "pv-nav-categories-included-with-prime",
    PV_NAV_CATEGORIES_KIDS = "pv-nav-categories-kids",
    PV_NAV_CATEGORIES_ORIGINALS = "pv-nav-categories-originals",
    PV_NAV_CATEGORIES_RECENTLY_ADDED = "pv-nav-categories-recently-added",
    PV_NAV_CATEGORIES_TOP_RATED = "pv-nav-categories-top-rated",
    PV_NAV_CATEGORIES_4K = "pv-nav-categories-4k-uhd",
    PV_NAV_CATEGORIES_CHRISTMAS = "pv-nav-categories-christmas",
    PV_NAV_CATEGORIES_FEATURED_DEALS = "pv-nav-categories-featured-deals",
    PV_NAV_CATEGORIES_LEAVING_SOON = "pv-nav-categories-leaving-soon",
    PV_NAV_CATEGORIES_NEW_RELEASES = "pv-nav-categories-new-releases",
    PV_NAV_CATEGORIES_SPORTS = "pv-nav-categories-sports",
    PV_NAV_CATEGORIES_EXPLORER = "pv-nav-categories-prime-video-explorer",
    PV_NAV_CATEGORIES_COMING_SOON = "pv-nav-categories-coming-soon",
    PV_NAV_CATEGORIES_SHORTS = "pv-nav-categories-shorts"
}

export interface NavLink {
    id: NavigationIdentifiers
    text: string,
    href: string,
    rel?: string,
    isHighlighted?: boolean
    pre?: string,
    post?: string,
    isPanel?: boolean,
    links?: NavLink[]
}

export interface NavigationLogo {
    altText: string;
    href: string;
    imageURL?: string;
}

export interface NavigationMainMenu {
    closeText: string;
    text: string;
    primaryLinks: NavLink[];
}

export interface NavigationSignUpCTA {
    text: string;
    href: string;
}

export interface NavigationSearchForm {
    altText: string;
    phrase: string;
    placeholder: string;
    action: {
        partialURL: string;
        query: {
            ie: string
        };
    };
    searchSuggestionsEndpoint: {
        partialURL: string;
        query: {
            ie: string
        };
    };
    searchHistory: {
        searchHistoryOn: Boolean;
        strings: {
            recent: string;
            suggested: string;
            clear: string;
            clearInfoTitle: string;
            clearInfoButton: string;
            clearInfoMessage: string;
            cancel: string;
            clearInfoAck: string;
        };
    };
};

export interface NavigationYourAccount {
    altText: string;
    firstName: string;
    links: NavLink[];
    strings: StringMap
};

export interface NavigationLocaleSelector {
    heading: string;
    currentLocaleText?: string;
    locales: NavLink[];
    languages: NavLanguage[];
};

export interface NavigationNewItemNotification {
    title: string;
    body: string;
    csrfToken: string;
};
